import { createFileRoute } from '@tanstack/react-router';

import { MigrationAssessmentRunPage } from '@/components/features/migration-assessment/MigrationAssessmentRunPage';

export const Route = createFileRoute('/_protected/t/$tenantId/migration-assessment/$runId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  return <MigrationAssessmentRunPage key={runId} runId={runId} />;
}
